import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  FinanceOffersCarouselBlock,
  FinanceOffersCarouselReference,
  FinanceRepresentativeReference,
} from '../organism-blocks'

export const wrappedStoryblokComponents: ComponentMap = {
  FinanceOffersCarousel: FinanceOffersCarouselBlock,
}

export const organismStoryblokComponents: ComponentMap = {
  ...wrappedStoryblokComponents,
  FinanceOffersCarouselReference,
  FinanceRepresentativeReference,
}
